<template>
    <CRow>
        <CCol v-if="state === 'edit' && check === false" sm="6">
            <v-select
                :options="availableChecksOpts"
                :placeholder="'Add ' + category.charAt(0).toUpperCase() + category.slice(1) + ' check'"
                :clearable="false"
                @input="onCheckNameSelectorSet"
                label="label"
                ref="checkSelector"
                class="mb-3 mt-n2 checkSelector"
            >
                <template #no-options="{}">
                        <span class="p-1" v-if="!availableChecks.length && category!=='other'">
                        There is no other checks available for {{ category.charAt(0).toUpperCase() + category.slice(1) }}.</span>
                    <span class="p-1" v-else-if="!availableChecks.length && category==='other'">
                        There is no other checks available for this section.</span>
                    <span class="p-1" v-else-if="(freeChecksSlotsQty < 1)">
                        Not enough slots in table. Delete any check.</span>
                </template>
                <template #search="{events, attributes}">
                    <!--suppress HtmlFormInputWithoutLabel -->
                    <input class="vs__search" style="line-height: 1" v-on="events" v-bind="attributes"/>
                </template>
            </v-select>
        </CCol>
        <template v-if="check">
            <CCol sm="6">
                <CButton class="p-0 mr-1" v-if="state === 'edit'" @click="deleteCheck">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon size="sm" style="color:#c28585" name="cilX"/>
                </CButton>
                <label class="mr-n4">{{ checksInfo[check.name].label }}</label>
                <!--                <CButton class="p-0 ml-2" v-c-tooltip="checksInfo[check.name].tooltip"-->
                <!--                         color="primary">-->
                <!--                    &lt;!&ndash;suppress HtmlUnknownTag &ndash;&gt;-->
                <!--                    <CIcon size="sm" style="opacity:0.4" name="cilInfo"/>-->
                <!--                </CButton>-->
            </CCol>
            <CCol sm="6">
                <CRow class="no-gutters">
                    <template v-if="checksInfo[check.name].selector === 'int_diap_spm'">
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="1" :max="kwarg01" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2" class="d-flex justify-content-center">
                            <div><span>...</span></div>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg01" size="sm" :min="kwarg00" max="99" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2"><span class="ml-1 mr-n3" style="font-size: 0.75rem">spm</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_diap_deg'">
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="-90" :max="kwarg01" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2" class="d-flex justify-content-center">
                            <div><span>...</span></div>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg01" size="sm" :min="kwarg00" max="90" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2"><span class="ml-1" style="font-size: 1.1rem">°</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_min_deg'">
                        <CCol col="6">
                            <span class="pr-1">if more than</span>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="0" max="180" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2"><span class="ml-1" style="font-size: 1.1rem">°</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_max_deg'">
                        <CCol col="6">
                            <span>if less than</span>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="0" max="180" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2"><span class="ml-1" style="font-size: 1.1rem">°</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_diap_percent_torso'">
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="0" :max="kwarg01" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2" class="d-flex justify-content-center">
                            <div><span>...</span></div>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg01" size="sm" :min="kwarg00" max="100" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2">
                            <div class="mt-n1 mr-n3" style="height: 50%;"><span class="ml-1" style="font-size: 0.75rem; line-height: 20px">% of</span>
                            </div>
                            <div class="mt-n2 mr-n3" style="height: 50%"><span class="ml-1" style="font-size: 0.75rem; line-height: 20px">torso</span>
                            </div>
                        </CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_diap_percent'">
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="0" :max="kwarg01" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2" class="d-flex justify-content-center">
                            <div><span>...</span></div>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg01" size="sm" :min="kwarg00" max="100" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2"><span class="ml-1">%</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'int_min_percent'">
                        <CCol col="6">
                            <span class="pr-1">more than</span>
                        </CCol>
                        <CCol col="4">
                            <CInput v-model="kwarg00" size="sm" min="0" max="100" step="1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol xs="2"><span class="ml-1" style="font-size: 0.75rem">%</span></CCol>
                    </template>
                    <template v-else-if="checksInfo[check.name].selector === 'dr_ratio_diap'">
                        <CCol col="4">
                            <CInput ref="kwarg00" v-model="kwarg00" size="sm" min="0.1" :max="kwarg01" step="0.1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2" class="d-flex justify-content-center">
                            <div><span>...</span></div>
                        </CCol>
                        <CCol col="4">
                            <CInput ref="kwarg01" v-model="kwarg01" size="sm" :min="kwarg00" max="3" step="0.1" :readonly="state === 'view' "
                                    :addInputClasses="state === 'view' ? 'no-spin' : ''"></CInput>
                        </CCol>
                        <CCol col="2">
                            <div class="mt-n1 mr-n3" style="height: 50%;"><span class="ml-1" style="font-size: 0.75rem; line-height: 20px">of</span>
                            </div>
                            <div class="mt-n2 mr-n3" style="height: 50%"><span class="ml-1" style="font-size: 0.75rem; line-height: 20px">drive</span>
                            </div>
                        </CCol>
                    </template>
                </CRow>
            </CCol>
        </template>
    </CRow>
</template>

<script>
    import {checksInfo} from "@/scripts/checks-schema"

    export default {
        props: {
            state: {},
            check: {},
            availableChecks: {},
            category: {},
            freeChecksSlotsQty: {},
        },
        model: {
            prop: 'check',
        },
        data() {
            return {
                checksInfo,
                checkName: null,
                kwarg00: null,
                kwarg01: null,
                kwargsKeys: []
            }
        },
        methods: {
            deleteCheck() {
                this.$emit('input', null)
                this.$emit('changed')
            },
            onCheckNameSelectorSet(val) {
                this.checkName = val.name
                let defaultKwargs = this.checksInfo[this.checkName]['default_kwargs']
                this.kwargsKeys = Object.keys(defaultKwargs)
                if (this.kwargsKeys.length >= 1) {
                    let kwarg0Val = defaultKwargs[this.kwargsKeys[0]]
                    if (kwarg0Val.length === 2) {
                        this.kwarg00 = kwarg0Val[0]
                        this.kwarg01 = kwarg0Val[1]
                    } else {
                        this.kwarg00 = kwarg0Val
                        this.kwarg01 = null
                    }
                } else {
                    this.kwarg00 = null
                    this.kwarg01 = null
                }
                this.onCheckChanged()
            },
            onCheckChanged() {
                if (this.checkName) {
                    let kwargs = {}
                    if (this.kwargsKeys.length >= 1) {
                        if (this.kwarg00 !== null && this.kwarg01 !== null) {
                            kwargs[this.kwargsKeys[0]] = [parseFloat(this.kwarg00), parseFloat(this.kwarg01)]
                        } else if (this.kwarg00 !== null) {
                            kwargs[this.kwargsKeys[0]] = parseFloat(this.kwarg00)
                        }
                    }
                    this.$emit('input', {name: this.checkName, kwargs: kwargs})
                } else
                    this.$emit('input', null)
                this.$emit('changed')
            },
            onCheckSet() {
                if (this.check) {
                    this.checkName = this.check.name
                    let defaultKwargs = this.checksInfo[this.checkName]['default_kwargs']
                    this.kwargsKeys = Object.keys(defaultKwargs)
                    if (this.kwargsKeys.length >= 1) {
                        let kwarg0Val = this.check['kwargs'][this.kwargsKeys[0]]
                        if (kwarg0Val.length === 2) {
                            this.kwarg00 = kwarg0Val[0]
                            this.kwarg01 = kwarg0Val[1]
                        } else {
                            this.kwarg00 = kwarg0Val
                            this.kwarg01 = null
                        }
                    } else {
                        this.kwarg00 = null
                        this.kwarg01 = null
                    }
                } else {
                    this.checkName = null
                    this.kwargsKeys = []
                    this.kwarg00 = null
                    this.kwarg01 = null
                }
            }
        },
        computed: {
            availableChecksOpts() {
                let res = []
                if (this.freeChecksSlotsQty >= 1)
                    for (let checkName of this.availableChecks)
                        res.push({
                            name: checkName,
                            label: checksInfo[checkName].label
                        })
                return res
            }
        },
        watch: {
            check() {
                this.onCheckSet()
            },
            kwarg00() {
                this.onCheckChanged()
            },
            kwarg01() {
                this.onCheckChanged()
            }
        },
        created() {
            this.onCheckSet()
        }

    }
</script>

<style lang="scss">
    .no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
    }

    .no-spin {
        -moz-appearance: textfield !important;
    }
</style>
